import React, { forwardRef, useMemo } from "react";
import { addIconSVG } from "./Icon.utils";
var Icon = forwardRef(function (_a, ref) {
    var icon = _a.icon, iconSvg = _a.iconSvg, size = _a.size, className = _a.className, style = _a.style;
    var iconClass = useMemo(function () {
        var classIcone = "";
        if (icon) {
            classIcone = icon;
        }
        if (size === "sm" || size === "lg") {
            classIcone += " fr-icon--".concat(size);
        }
        if (className) {
            classIcone += " ".concat(className);
        }
        return classIcone.trim();
    }, [icon, size, className]);
    var _b = addIconSVG(iconSvg, iconClass, style), iconClassName = _b.className, iconStyle = _b.style;
    return React.createElement("span", { ref: ref, className: iconClassName, style: iconStyle });
});
export default Icon;
